import React, { useEffect, useState } from "react";
import { TableCell, TableRow } from "@material-ui/core";
import {
  ModalDeleteConfirm,
  TableWrapper,
  TableAction,
  Title,
  TableCellDefault,
  MasterButton,
} from "App/Component/ui";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  FormMasterGudang,
  headCells,
  STYLE_MASTER_GUDANG,
  RESET_STATE_MASTER_GUDANG,
  urlGet,
  deleteMasterGudangById,
} from "./ui";

import { useFetch, useDatatables } from "App/hooks";
import {
  scrollToTop,
  fetchData,
  defaultToastSuccess,
  defaultToastError,
  defaultDateDisplay,
} from "App/utils/helpers";
import { TYPE_INSTANCE4 } from "App/constants";
import {
  FilterColumns,
  PrepareDataExportAdvenced,
} from "App/Component/layout/MasterData/helpers";
import { isEmpty } from "lodash";

export default function GudangUtama() {
  const classes = STYLE_MASTER_GUDANG();
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [rows, setRows] = useFetch(TYPE_INSTANCE4, urlGet, "data");

  const [formData, setFormData] = useState(RESET_STATE_MASTER_GUDANG);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  // function clickAdd() {
  //   setFormData(RESET_STATE_MASTER_GUDANG);
  // }

  function clickUpdate(row) {
    scrollToTop();
    setFormData({
      id: row?.gudangId,
      name: row?.name,
      id_gudang: row?.id_gudang,
      id_unit: row?.id_unit,
      unit: row.namaUnit,
      status_jual: row.status_jual,
    });
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.gudangId,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function setNewData() {
    const res = await fetchData(TYPE_INSTANCE4, urlGet, "data");
    setRows(res);
  }

  async function deleteList() {
    const res = await deleteMasterGudangById(formData.id);

    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  const prepareHeaders = {
    gudangId: {
      key: "id",
      value: "gudangId",
    },
    nama: {
      key: "nama",
      value: "name",
    },
    namaGudangUtama: {
      key: "namaGudangUtama",
      value: "namaGudangUtama",
    },
    namaUnit: {
      key: "namaUnit",
      value: "namaUnit",
    },
    createdAt: {
      key: "createdAt",
      value: (row) => defaultDateDisplay(row.createdAt),
    },
    createdName: {
      key: "createdName",
      value: "createdName",
    },
    updatedAt: {
      key: "updatedAt",
      value: (row) => defaultDateDisplay(row.updatedAt),
    },
    updatedName: {
      key: "updatedName",
      value: "updatedName",
    },
  };

  const dataExport = PrepareDataExportAdvenced(rows, prepareHeaders);
  const headerExport = FilterColumns(dataExport);

  return (
    <div className={classes.root}>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <Title title="Gudang Perbekalan Farmasi" />

      <FormMasterGudang
        formData={formData}
        setFormData={setFormData}
        setNewData={setNewData}
      />

      <div className="mt-2">
        <TableWrapper
          title="Daftar Gudang Perbekalan Farmasi"
          setQ={setQ}
          withAddButton={false}
          withExportButton={true}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={rows}
          headCells={headCells}
          page={page}
          setPage={setPage}
          allData={dataExport}
          headers={headerExport}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        >
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    padding="none"
                    align="center"
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell component="th" scope="row" padding="none">
                    <TableAction
                      clickDelete={() => clickDelete(row)}
                      clickUpdate={() => clickUpdate(row)}
                    />
                  </TableCell>
                  <TableCell align="left">{row?.gudangId}</TableCell>
                  <TableCell align="left">{row?.name}</TableCell>
                  <TableCell align="left">{row?.namaGudangUtama}</TableCell>
                  <TableCell align="left">{row?.namaUnit}</TableCell>
                  <TableCell align="left">
                    {row?.status_jual ? (
                      <MasterButton
                        name="Ya"
                        color="lightgreen"
                        type="button"
                      />
                    ) : (
                      <MasterButton name="Tidak" color="danger" type="button" />
                    )}
                  </TableCell>
                  <TableCellDefault row={row} type="custom" />
                </TableRow>
              );
            })}
        </TableWrapper>
      </div>
    </div>
  );
}
